"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addTimeout = addTimeout;
function addTimeout(promise, _a) {
    var time = _a.time, reason = _a.reason;
    return new Promise(function (resolve, reject) {
        var timerId = setTimeout(reject, time, reason);
        var cancel = function () { return clearTimeout(timerId); };
        promise.then(cancel, cancel);
        promise.then(resolve, reject);
    });
}
//# sourceMappingURL=addTimeout.js.map